import { useReportFoldersContext } from '@views/pages/Reporting/ReportFolders/context';
import { useOrganizationsShortQuery } from '@common/cache';
import { SyntheticEvent } from 'react';

export const useReportFoldersTableFilters = () => {
  const { handleFilterChange, filters } = useReportFoldersContext();

  const { data: organizationList = [] } = useOrganizationsShortQuery();

  const handleSelectOrg = (
    event: SyntheticEvent<Element, Event>,
    value: { id: string; name: string } | null,
  ) => {
    handleFilterChange({
      organization_id: value?.id,
    });
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleFilterChange({
      search: e.target.value,
    });
  };

  return {
    handleSearchChange,
    org: organizationList.find(item => filters.organization_id === item.id),
    handleSelectOrg,
    organizationOptions: organizationList,
    filters,
  };
};
